@Inject('Notifications')
export class RwTermsOfUseController {
  showDialog() {
    this.Notifications.showComplexDialog({
      component: 'rwTermsOfUseDialog',
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/rw-terms-of-use-controller.js